import parsePhoneNumber, { type CountryCode } from 'libphonenumber-js';

export function maskPhone(value: string, country?: string) {
  const numberValue = value?.replace(/[a-zA-Z]/gi, '');

  if (numberValue && numberValue.length > 0) {
    const parseNumber =
      country != null
        ? parsePhoneNumber(numberValue.toString(), country as CountryCode)
        : parsePhoneNumber(numberValue.toString());

    if (parseNumber == null) return numberValue;

    const countryCallingCode = parseNumber.countryCallingCode.toString();
    const internNumber = parseNumber.formatInternational();

    const formatted = internNumber.startsWith(`+${countryCallingCode}`)
      ? internNumber.slice(countryCallingCode.length + 1).trim()
      : parseNumber.nationalNumber;

    return formatted;
  }

  return numberValue;
}

export const maskCardNumber = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const maskCvvCredit = [/\d/, /\d/, /\d/, /\d/];

export const maskExpirationDate = [/\d/, /\d/];

export function mailMask(value: string) {
  return value != null ? value.replace(/\s+/g, '') : value;
}
